import {
  Passthrough,
  ResponsiveLayout,
} from '@robovision/rvai-base'
import { RouteNames } from '../moduleRouteNames/plugins'
import type { RvaiRouteRecord } from '../types'


// We need to ignore "imports" for components properties in routes,
// because without it we have no possibility to import (dynamically) pages for specific router.
// Normally we don't need to import something from "pages" into router,
// but eslint doesn't know the difference between normal and dynamic imports.
export const routes: RvaiRouteRecord<RouteNames> = {
  children: [
    {
      children: [
        {
          // eslint-disable-next-line import/no-restricted-paths
          component: () => import('~modules/plugins/pages/PluginDetails.vue'),
          name: RouteNames.PluginDetails,
          path: ':pluginName',
        },
        {
          // eslint-disable-next-line import/no-restricted-paths
          component: () => import('~modules/plugins/pages/Plugins.vue'),
          name: RouteNames.Plugins,
          path: '',
        },
      ],
      component: ResponsiveLayout,
      path: '',
    },
  ],
  component: Passthrough,
  path: '/plugins',
}
